import { render, staticRenderFns } from "./Chief.vue?vue&type=template&id=ac2fac26&scoped=true"
import script from "./Chief.vue?vue&type=script&lang=js"
export * from "./Chief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2fac26",
  null
  
)

export default component.exports